import { Action } from '@ngrx/store';
import { AuthState, LoginState } from '../reducers/shell.reducer';
import { User } from '../../shared/models/user';

export enum RootActionTypes {
  SetProcessing = '[Root] Set Processing',
  SetErrorMessage = '[Root] Set Error Message',
  GetToken = '[Root] GetToken',
  GetTokenSuccess = '[Root] GetTokenSuccess',
  GetTokenFailure = '[Root] GetTokenFailure',
  ShowModalLogin = '[Root] ShowModalLogin',
  GetModalLoginForm = '[Root] GetModalLoginForm',
  GetModalLoginFormSuccess = '[Root] GetModalLoginFormSuccess',
  PostModalLogin = '[Root] PostModalLogin',
  ModalLoginSuccess = '[Root] ModalLoginSuccess',
  ModalLoginFailure = '[Root] ModalLoginFailure',
  ResetSessionExtended = '[Root] ResetSessionExtended',
  ExtendSessionTimestamp = '[Root] ExtendSessionTimestamp',
  GetLoggedInStatus = '[Root] GetLoggedInStatus',
  GetLoggedInStatusSuccess = '[Root] GetLoggedInStatusSuccess',
  GetLoggedInStatusFailure = '[Root] GetLoggedInStatusFailure',
}

export class SetErrorMessage implements Action {
  readonly type = RootActionTypes.SetErrorMessage;

  constructor(public payload: number) { }
}

export class SetProcessing implements Action {
  readonly type = RootActionTypes.SetProcessing;

  constructor(public payload: boolean) { }
}

export class GetToken implements Action {
  readonly type = RootActionTypes.GetToken;

  constructor() { }
}

export class GetTokenSuccess implements Action {
  readonly type = RootActionTypes.GetTokenSuccess;

  constructor(public payload: AuthState) { }
}

export class GetTokenFailure implements Action {
  readonly type = RootActionTypes.GetTokenFailure;

  constructor(public payload: string) { }
}

export class ShowModalLogin implements Action {
  readonly type = RootActionTypes.ShowModalLogin;

  constructor(public payload: string) { }
}

export class GetModalLoginForm implements Action {
  readonly type = RootActionTypes.GetModalLoginForm;

  constructor() { }
}

export class GetModalLoginFormSuccess implements Action {
  readonly type = RootActionTypes.GetModalLoginFormSuccess;

  constructor(public payload: string) { }
}

export class PostModalLogin implements Action {
  readonly type = RootActionTypes.PostModalLogin;

  constructor(public payload: LoginState) { }
}

export class ModalLoginSuccess implements Action {
  readonly type = RootActionTypes.ModalLoginSuccess;

  constructor(public payload: boolean) { }
}

export class ModalLoginFailure implements Action {
  readonly type = RootActionTypes.ModalLoginFailure;

  constructor(public payload: string) { }
}

export class ResetSessionExtended implements Action {
  readonly type = RootActionTypes.ResetSessionExtended;

  constructor() { }
}

export class ExtendSessionTimestamp implements Action {
  readonly type = RootActionTypes.ExtendSessionTimestamp;

  constructor() { }
}

export class GetLoggedInStatus implements Action {
  readonly type = RootActionTypes.GetLoggedInStatus;

  constructor() { }
}

export class GetLoggedInStatusSuccess implements Action {
  readonly type = RootActionTypes.GetLoggedInStatusSuccess;

  constructor() { }
}

export class GetLoggedInStatusFailure implements Action {
  readonly type = RootActionTypes.GetLoggedInStatusFailure;

  constructor() { }
}


export type ShellActionsUnion =
  SetProcessing |
  SetErrorMessage |
  GetToken |
  GetTokenSuccess |
  GetTokenFailure |
  ShowModalLogin |
  GetModalLoginForm |
  GetModalLoginFormSuccess |
  PostModalLogin |
  ModalLoginSuccess |
  ModalLoginFailure |
  ResetSessionExtended |
  ExtendSessionTimestamp |
  GetLoggedInStatus |
  GetLoggedInStatusSuccess |
  GetLoggedInStatusFailure;
